export const lineWidth = 0.3;
export const lineWidthV2 = 0.25;
